import { LOADED } from "./actionTypes";
import postsInitialState from "./initialState";

const postsReducer = (state = postsInitialState, { type, payload }) => {
    switch (type) {
        case LOADED:
            return [...payload]

        default:
            return state;
    }
}

export default postsReducer;